// extracted by mini-css-extract-plugin
export default {"container":"container__ZDgyN","title":"title__YTc1N","description":"description__ODdkM","dismiss":"dismiss__MDFlN"};